import { LanguageModule, LanguageServiceConfig } from '@ibank-globals/language';
import { NgModule, ModuleWithProviders, LOCALE_ID, InjectionToken } from '@angular/core';
import { AppEndpoints } from './app.endpoints';
import { MetaData } from '@nbg-globals/urlbuilder';

export function getLocaleId(): string {
	return new MetaData().get('lng');
}

export const lmConfig: LanguageServiceConfig = {
	multilanguage: new MetaData().get('multilanguage').toLowerCase() == 'true',
	defaultLanguage: 'el',
	changeLanguageUrl: AppEndpoints.setLanguageUrl,
	resourcesUrl: AppEndpoints.getResources,
	defaultResource: 'login',
	antiforgeryMetaName: '_af'
};

// Create a custom LocaleId token that matches what @ibank-globals/language might expect
export const LOCALE_ID_TOKEN = new InjectionToken<string>('LocaleId');

@NgModule({
	imports: [LanguageModule],
	exports: [LanguageModule]
})
export class AppLanguageModule {
	public static forRoot(): ModuleWithProviders<AppLanguageModule> {
		const languageModuleWithProviders = LanguageModule.forRoot();
		
		return {
			ngModule: AppLanguageModule,
			providers: [
				{ provide: LOCALE_ID, useFactory: getLocaleId },
				{ provide: LOCALE_ID_TOKEN, useFactory: getLocaleId },
				{ provide: LanguageServiceConfig, useValue: lmConfig },
				...(languageModuleWithProviders.providers || [])
			]
		};
	}
}
